import React, { useState } from 'react';
import Hero from '../components/Hero';
import ModalCandidatura from '../components/ModalCandidatura';
import Notification from '../components/Notification';
import { FaMicroscope, FaGlobe, FaGraduationCap, FaHandshake, FaUsers, FaBriefcase, FaLink } from 'react-icons/fa';
import { useLanguage } from '../contexts/LanguageContext';

const TrabalheConosco = () => {
  const { t } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleNotification = (message, type) => {
    setNotification({ message, type });
  };
  const beneficios = [
    {
      icone: <FaMicroscope className="text-emerald-600" />,
      titulo: t('workWithUs.whyWork.benefits.0.title'),
      descricao: t('workWithUs.whyWork.benefits.0.description')
    },
    {
      icone: <FaGlobe className="text-emerald-600" />,
      titulo: t('workWithUs.whyWork.benefits.1.title'),
      descricao: t('workWithUs.whyWork.benefits.1.description')
    },
    {
      icone: <FaGraduationCap className="text-emerald-600" />,
      titulo: t('workWithUs.whyWork.benefits.2.title'),
      descricao: t('workWithUs.whyWork.benefits.2.description')
    },
    {
      icone: <FaHandshake className="text-emerald-600" />,
      titulo: t('workWithUs.whyWork.benefits.3.title'),
      descricao: t('workWithUs.whyWork.benefits.3.description')
    }
  ];

  const tiposColaboracao = [
    {
      icone: <FaBriefcase className="text-emerald-600" />,
      titulo: t('workWithUs.collaboration.types.0.title'),
      descricao: t('workWithUs.collaboration.types.0.description'),
      detalhes: t('workWithUs.collaboration.types.0.areas')
    },
    {
      icone: <FaMicroscope className="text-emerald-600" />,
      titulo: t('workWithUs.collaboration.types.1.title'),
      descricao: t('workWithUs.collaboration.types.1.description'),
      detalhes: t('workWithUs.collaboration.types.1.areas')
    },
    {
      icone: <FaLink className="text-emerald-600" />,
      titulo: t('workWithUs.collaboration.types.2.title'),
      descricao: t('workWithUs.collaboration.types.2.description'),
      detalhes: t('workWithUs.collaboration.types.2.areas')
    },
    {
      icone: <FaUsers className="text-emerald-600" />,
      titulo: t('workWithUs.collaboration.types.3.title'),
      descricao: t('workWithUs.collaboration.types.3.description'),
      detalhes: t('workWithUs.collaboration.types.3.areas')
    }
  ];

  const processoSeletivo = [
    {
      passo: "1",
      titulo: t('workWithUs.process.steps.0.title'),
      descricao: t('workWithUs.process.steps.0.description')
    },
    {
      passo: "2",
      titulo: t('workWithUs.process.steps.1.title'),
      descricao: t('workWithUs.process.steps.1.description')
    },
    {
      passo: "3",
      titulo: t('workWithUs.process.steps.2.title'),
      descricao: t('workWithUs.process.steps.2.description')
    },
    {
      passo: "4",
      titulo: t('workWithUs.process.steps.3.title'),
      descricao: t('workWithUs.process.steps.3.description')
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <Hero
        title={t('workWithUs.hero.title')}
        subtitle={t('workWithUs.hero.subtitle')}
        description={t('workWithUs.hero.description')}
        showButtons={false}
      />

      {/* Por que trabalhar conosco */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full mb-6">
              <span className="text-emerald-600 text-sm font-medium">// {t('workWithUs.whyWork.badge').replace('// ', '')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              <span className="block">{t('workWithUs.whyWork.title')}</span>
              <span className="block bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
                {t('workWithUs.whyWork.titleHighlight')}
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('workWithUs.whyWork.description')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {beneficios.map((beneficio, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-emerald-200">
                <div className="text-5xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  {beneficio.icone}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-emerald-600 transition-colors duration-300">
                  {beneficio.titulo}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {beneficio.descricao}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Botão de Inscrição */}
      <section className="py-16 bg-gradient-to-br from-emerald-600 to-teal-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            {t('workWithUs.cta.title')}
          </h2>
          <p className="text-xl text-emerald-100 mb-8 max-w-2xl mx-auto">
            {t('workWithUs.cta.description')}
          </p>
          <button
            onClick={() => setIsModalOpen(true)}
            className="group bg-white text-emerald-600 hover:bg-gray-50 px-8 py-4 rounded-xl font-semibold transition-all duration-300 shadow-2xl hover:shadow-white/25 flex items-center space-x-2 mx-auto"
          >
            <span>{t('workWithUs.cta.button')}</span>
            <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
        </div>
      </section>

      {/* Tipos de Colaboração */}
      <section className="py-20 bg-gradient-to-br from-slate-50 to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full mb-6">
              <span className="text-emerald-600 text-sm font-medium">// {t('workWithUs.collaboration.badge').replace('// ', '')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('workWithUs.collaboration.title')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('workWithUs.collaboration.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {tiposColaboracao.map((tipo, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-emerald-200">
                <div className="flex items-start space-x-4 mb-6">
                  <div className="text-4xl group-hover:scale-110 transition-transform duration-300">
                    {tipo.icone}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-emerald-600 transition-colors duration-300">
                      {tipo.titulo}
                    </h3>
                    <p className="text-gray-600 leading-relaxed mb-4">
                      {tipo.descricao}
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  <h4 className="font-semibold text-gray-900">{t('workWithUs.collaboration.areasLabel')}</h4>
                  <ul className="space-y-2">
                    {tipo.detalhes.map((detalhe, idx) => (
                      <li key={idx} className="flex items-start space-x-3">
                        <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 flex-shrink-0"></div>
                        <span className="text-gray-600 text-sm">{detalhe}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processo Seletivo */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-emerald-100 rounded-full mb-6">
              <span className="text-emerald-600 text-sm font-medium">// {t('workWithUs.process.badge').replace('// ', '')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('workWithUs.process.title')}
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('workWithUs.process.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processoSeletivo.map((passo, index) => (
              <div key={index} className="text-center group">
                <div className="w-20 h-20 bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <span className="text-2xl font-bold text-white">{passo.passo}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-emerald-600 transition-colors duration-300">
                  {passo.titulo}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {passo.descricao}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-br from-slate-900 via-teal-900 to-emerald-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-emerald-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal-400 rounded-full mix-blend-multiply filter blur-xl animate-pulse delay-1000"></div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            {t('workWithUs.questions.title')}
          </h2>
          <p className="text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
            {t('workWithUs.questions.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="/contato"
              className="group bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-8 py-4 rounded-xl font-semibold hover:from-emerald-600 hover:to-teal-700 transition-all duration-300 shadow-2xl hover:shadow-emerald-500/25 flex items-center justify-center space-x-2"
            >
              <span>{t('workWithUs.questions.buttons.contact')}</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
            <a
              href="mailto:contato@conexaosaude.org"
              className="group border-2 border-white/30 text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-slate-900 transition-all duration-300 backdrop-blur-sm flex items-center justify-center space-x-2"
            >
              <span>{t('workWithUs.questions.buttons.email')}</span>
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Modal de Candidatura */}
      <ModalCandidatura
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onNotification={handleNotification}
      />

      {/* Notificação */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default TrabalheConosco;